<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
};
</script>

<style lang="scss">
  *{
    margin: 0;
    padding: 0;
  }
  img{
    image-rendering: -moz-crisp-edges; /* Firefox */
    image-rendering: -o-crisp-edges; /* Opera */
    image-rendering: -webkit-optimize-contrast; /* Webkit (non-standard naming) */
    image-rendering: crisp-edges;   
    -ms-interpolation-mode: nearest-neighbor; /* IE (non-standard property) */
    image-rendering: crisp-edges;
  }
/* 在全局样式或组件样式中使用 @font-face 引入本地字体 */
  @font-face {
    font-family: 'Butler';  /* 定义字体名称 */
    src: url('../static/Butler/Butler/Butler-Regular-13.otf') format('opentype');  /* 引入 .woff字体 */
    font-weight: normal;
    font-style: normal;
  }
  /* 在样式中使用该字体 */
  * {
    font-family: Inter;
    // font-family: 'Butler';  /* 使用 Butler 字体 */
  }

  // /* pc端 */
  @media (min-width: 1440px) {
    html {
      font-size: 16px; /* 更大屏幕字体大小 */
    }
  }

  @media (min-width: 1201px) and (max-width: 1439px) {
    html {
      font-size: 14px; /* 中等屏幕字体大小 */
    }
  }

  @media (min-width: 1025px) and (max-width: 1200px) {
    html {
      font-size: 11.4px; /* 中小屏幕字体大小 */
    }
  }

  /* 普通平板 */
  @media (min-width: 800px) and (max-width: 1024px) {
    html {
      font-size: 10px; /* 平板设备字体大小 */
    }
  }

  /* 手机端 */
  @media (max-width: 799px) {
    html {
      font-size: 16px; /* 手机端字体大小 */
    }
  }
  .navBackground{
    background-color: rgba(0, 0, 0, 1) !important;
    .tabItem{
      color: #FFF !important;
    }
    .isTabActive{
      border-bottom: 0.125rem solid #FFF !important;
    }
  }
/* 一些样式 */
</style>